/** The URL of the stat-block form of a document (1.AC-2 deliverable 3). */
export interface SheetFormHrefOptions {
  readonly sheetId?: string | undefined;
  readonly compare?: boolean | undefined;
}

export function sheetFormHref(docId: string, options: SheetFormHrefOptions = {}): string {
  const query = new URLSearchParams();
  if (options.sheetId) query.set('sheet', options.sheetId);
  if (options.compare) query.set('compare', '1');
  const text = query.toString();
  return `/sheets/${docId}${text === '' ? '' : `?${text}`}`;
}
